import { useEffect, useState, useRef } from 'react';
import { getClients } from '@/lib/api';

export default function ClientSlider() {
  const [clients, setClients] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = async () => {
    try {
      const res = await getClients();
      // Duplicate for seamless loop
      setClients([...res.data, ...res.data]);
    } catch (err) {
      // Use placeholder clients if no data
      const placeholders = [
        { id: '1', name: 'Tech Corp', logo: 'https://via.placeholder.com/150x50/121212/888888?text=TechCorp' },
        { id: '2', name: 'Innovate Inc', logo: 'https://via.placeholder.com/150x50/121212/888888?text=Innovate' },
        { id: '3', name: 'Growth Co', logo: 'https://via.placeholder.com/150x50/121212/888888?text=GrowthCo' },
        { id: '4', name: 'Scale Up', logo: 'https://via.placeholder.com/150x50/121212/888888?text=ScaleUp' },
        { id: '5', name: 'Revenue Pro', logo: 'https://via.placeholder.com/150x50/121212/888888?text=RevenuePro' },
      ];
      setClients([...placeholders, ...placeholders]);
    }
  };

  if (clients.length === 0) return null;

  return (
    <div className="logo-slider overflow-hidden py-8" data-testid="client-slider">
      <div
        ref={sliderRef}
        className="flex gap-16 animate-marquee"
        style={{ width: 'max-content' }}
      >
        {clients.map((client, idx) => (
          <div
            key={`${client.id}-${idx}`}
            className="flex-shrink-0 flex items-center justify-center h-16 px-8 grayscale hover:grayscale-0 opacity-50 hover:opacity-100 transition-all duration-500"
          >
            {client.logo ? (
              <img
                src={client.logo}
                alt={client.name}
                className="h-full w-auto object-contain"
              />
            ) : (
              <span className="text-2xl font-bold text-[#333] font-syne">{client.name}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
